Controller = App.loadClass 'core::Angular/Controller'

class exports.TillagePracticeController extends Controller
    constructor: (
        @scope,
        @transitions,
        @modal,
        @http,
        @service,
        @state
    ) ->
        super
